import { categoryList } from "../../../mocks/baogua";

export default function CategoryNav() {
  return (
    <section id="category" className="bg-[#f2ead9] py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl mb-10">
          <h2 className="font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a]">
            挑个喜欢的<span className="text-emerald-600">瓜田</span>进去坐坐
          </h2>
          <p className="mt-3 text-[#201d1a]/60">
            按主题划分的爆料专区，想追娱乐大瓜、消费避坑还是职场见闻，一键直达对应话题现场。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryList.map((cat) => (
            <a
              key={cat.name}
              href="#feed"
              className="group flex items-center gap-4 p-5 rounded-2xl bg-white border border-amber-900/10 hover:border-emerald-600/30 hover:-translate-y-0.5 transition-all cursor-pointer"
            >
              <span className={`grid w-[52px] h-[52px] place-items-center rounded-xl ${cat.color} shrink-0`}>
                <i className={`${cat.icon} w-6 h-6 flex items-center justify-center`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-serif-cn font-bold text-lg text-[#201d1a]">{cat.name}专区</span>
                  <span className="text-xs text-[#201d1a]/40 whitespace-nowrap">{cat.count}篇</span>
                </span>
                <span className="block mt-0.5 text-sm text-[#201d1a]/55 truncate">{cat.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line w-5 h-5 flex items-center justify-center text-[#201d1a]/30 group-hover:text-emerald-600 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}